import script from "./cardPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./cardPerformance.vue?vue&type=script&setup=true&lang=js"

import "./cardPerformance.vue?vue&type=style&index=0&id=688606a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688606a6"]])

export default __exports__